import {
  IHolidayItem,
  IHolidaysSectionState,
  IProviderProductObject,
  IServiceEditState,
  IServiceEditSteps,
  IServiceObject,
  IServiceProvider,
  IServiceProviderSectionState,
  IWorkingHoursItem,
  IWorkingHoursSectionState
} from '../../../types/index'
import { IServiceActions } from '../../actions/services/index'
import * as constants from '../../constants/index'

const initialServiceEditState: IServiceEditState = {
  steps: {
    list: [
      {
        name: 'mainInfo',
        url: constants.SERVICE_EDIT_URL.MAIN_INFO,
        title: 'MAIN INFO',
        required: true,
        completed: false
      },
      {
        name: 'products',
        url: constants.SERVICE_EDIT_URL.PRODUCTS,
        title: 'PRODUCTS',
        required: false,
        completed: false
      },
      {
        name: 'serviceDays',
        url: constants.SERVICE_EDIT_URL.SERVICE_DAYS_AND_HOURS,
        title: 'SERVICE DAYS & HOURS',
        required: false,
        completed: false
      },
      {
        name: 'goinZones',
        url: constants.SERVICE_EDIT_URL.GOIN_ZONES,
        title: 'GOIN ZONES',
        required: false,
        completed: false
      },
      {
        name: 'pricingBreakdown',
        url: constants.SERVICE_EDIT_URL.PRICING_BREAKDOWN,
        title: 'PRICING BREAKDOWN',
        required: false,
        completed: false
      },
      {
        name: 'member',
        url: constants.SERVICE_EDIT_URL.MEMBER,
        title: 'MEMBER',
        required: false,
        completed: false
      },
      {
        name: 'passengerType',
        url: constants.SERVICE_EDIT_URL.PASSENGER_TYPES,
        title: 'PASSENGER TYPES',
        required: false,
        completed: false
      },
      {
        name: 'suggestedLocations',
        url: constants.SERVICE_EDIT_URL.SUGGESTED_LOCATIONS,
        title: 'SUGGESTED LOCATIONS',
        required: false,
        completed: false
      },
      {
        name: 'groupRideSettings',
        url: constants.SERVICE_EDIT_URL.GROUP_RIDE_SETTINGS,
        title: 'GROUP RIDE SETTINGS',
        required: false,
        completed: false
      },
      {
        name: 'designatedHotspots',
        url: constants.SERVICE_EDIT_URL.DESIGNATED_HOTSPOTS,
        title: 'DESIGNATED HOTSPOTS',
        required: false,
        completed: false
      }
    ],
    currentStep: {
      position: -1,
      fetching: false,
      fetchingError: '',
      updating: false,
      updatingError: '',
      changed: false
    }
  },
  providersSection: {
    providers: [],
    serviceProviders: []
  },
  workingHoursSection: {
    allDaysActive: true,
    list: {}
  },
  holidaysSection: {
    list: {}
  }
}

export function serviceEdit(
  state: IServiceEditState = initialServiceEditState,
  action: IServiceActions
): IServiceEditState {
  if (action.type === constants.SERVICE_EDIT_CLEAR_STATE) {
    initialServiceEditState.steps.list.forEach(it => (it.completed = false))
    return initialServiceEditState
  }

  return {
    steps: stepsReducer(state.steps, action),
    providersSection: providersSectionReducer(state.providersSection, action),
    workingHoursSection: workingHoursSectionReducer(state.workingHoursSection, action),
    holidaysSection: holidaysSectionReducer(state.holidaysSection, action)
  }
}

export function stepsReducer(state: IServiceEditSteps, action: IServiceActions): IServiceEditSteps {
  switch (action.type) {
    case constants.SERVICE_EDIT_SET_COMPLETED: {
      const { step, completed } = action.payload
      state.list[step].completed = completed
      return Object.assign({}, state, { list: [...state.list] })
    }
    case constants.SERVICE_EDIT_SET_CURRENT_STEP: {
      const currentStep = action.payload
      return Object.assign({}, state, { currentStep })
    }
    case constants.SERVICE_EDIT_SET_FETCHING: {
      const fetching = action.payload
      return Object.assign({}, state, {
        currentStep: { ...state.currentStep, fetching }
      })
    }
    case constants.SERVICE_EDIT_SET_FETCHING_ERROR: {
      const error = action.payload
      return Object.assign({}, state, {
        currentStep: { ...state.currentStep, fetchingError: error }
      })
    }
    case constants.SERVICE_EDIT_SET_UPDATING: {
      const updating = action.payload
      return Object.assign({}, state, {
        currentStep: { ...state.currentStep, updating }
      })
    }
    case constants.SERVICE_EDIT_SET_UPDATING_ERROR: {
      const error = action.payload
      return Object.assign({}, state, {
        currentStep: { ...state.currentStep, updatingError: error }
      })
    }
    case constants.SERVICE_EDIT_SET_CHANGED: {
      const changed = action.payload
      return Object.assign({}, state, {
        currentStep: { ...state.currentStep, changed }
      })
    }
    default:
      return state
  }
}

//TODO figure this out
function providersSectionReducer(
  state: IServiceProviderSectionState,
  action: IServiceActions
): IServiceProviderSectionState {
  switch (action.type) {
    default:
      return state
  }
}

export function workingHoursSectionReducer(
  state: IWorkingHoursSectionState,
  action: IServiceActions
): IWorkingHoursSectionState {
  switch (action.type) {
    case constants.WORKING_HOURS_SUCCESS: {
      const workingHoursList = action.payload
      return Object.assign({}, state, {
        list: workingHoursList
      })
    }
    case constants.WORKING_HOURS_ADD_ITEM: {
      const workingHours = action.payload
      return Object.assign({}, state, {
        list: {
          ...state.list,
          [workingHours.id]: workingHours
        }
      })
    }
    case constants.WORKING_HOURS_REMOVE_ITEM_SUCCESS: {
      const id = action.payload
      delete state.list[id]
      return Object.assign({}, state, { list: { ...state.list } })
    }
    case constants.WORKING_HOURS_SET_FROM: {
      const { workingHoursId, from } = action.payload
      return Object.assign({}, state, {
        list: {
          ...state.list,
          [workingHoursId]: { ...state.list[workingHoursId], from }
        }
      })
    }
    case constants.WORKING_HOURS_SET_UNTIL: {
      const { workingHoursId, until } = action.payload
      return Object.assign({}, state, {
        list: {
          ...state.list,
          [workingHoursId]: { ...state.list[workingHoursId], until }
        }
      })
    }
    case constants.WORKING_HOURS_SET_DAYS: {
      const { workingHoursId, days } = action.payload
      return Object.assign({}, state, {
        list: {
          ...state.list,
          [workingHoursId]: { ...state.list[workingHoursId], days }
        }
      })
    }
    default:
      return state
  }
}

export function holidaysSectionReducer(state: IHolidaysSectionState, action: IServiceActions): IHolidaysSectionState {
  switch (action.type) {
    case constants.HOLIDAYS_SUCCESS: {
      const holidaysList = action.payload
      return Object.assign({}, state, {
        list: holidaysList
      })
    }
    case constants.HOLIDAYS_ADD_ITEM: {
      const holidayItem = action.payload
      return Object.assign({}, state, {
        list: {
          ...state.list,
          [holidayItem.id]: holidayItem
        }
      })
    }
    case constants.HOLIDAYS_REMOVE_ITEM: {
      const holidayItem = action.payload
      delete state.list[holidayItem.id]
      return Object.assign({}, state, { list: { ...state.list } })
    }
    case constants.HOLIDAYS_SET_FROM: {
      const { holidayItemId, from } = action.payload
      return Object.assign({}, state, {
        list: {
          ...state.list,
          [holidayItemId]: { ...state.list[holidayItemId], from }
        }
      })
    }
    case constants.HOLIDAYS_SET_UNTIL: {
      const { holidayItemId, until } = action.payload
      return Object.assign({}, state, {
        list: {
          ...state.list,
          [holidayItemId]: { ...state.list[holidayItemId], until }
        }
      })
    }
    case constants.HOLIDAYS_SET_DATE: {
      const { holidayItemId, date } = action.payload
      return Object.assign({}, state, {
        list: {
          ...state.list,
          [holidayItemId]: { ...state.list[holidayItemId], date }
        }
      })
    }
    case constants.HOLIDAY_REMOVE_ITEM_SUCCESS: {
      const id = action.payload
      delete state.list[id]
      return Object.assign({}, state, { list: { ...state.list } })
    }
    default:
      return state
  }
}

function getProviderProductsUpdated(
  serviceProvider: IServiceProvider,
  product: IProviderProductObject
): IServiceProvider {
  let updatedProducts
  if (!serviceProvider.products) {
    updatedProducts = [product]
  }
  if (!!serviceProvider.products && !serviceProvider.products.includes(product)) {
    updatedProducts = [...serviceProvider.products, product]
  }
  if (!!serviceProvider.products && serviceProvider.products.includes(product)) {
    updatedProducts = serviceProvider.products.filter(it => it.id !== product.id)
  }
  return { ...serviceProvider, products: updatedProducts }
}



// WEBPACK FOOTER //
// ./src/state/reducers/services/edit.ts